// Supplier / service-provider categories. These are now ONE and the same as
// the unified yacht systems taxonomy (lib/systems.js), so the Network supplier
// directory, the Invoices category dropdown and the Tasks system picker all
// share a single source of truth — a task system matches suppliers 1:1.
//
// Order matters — it's the display order in every dropdown.

import { UNIFIED_SYSTEMS, labelForSystem } from "./systems";

// value === label now (no more slug keys). Kept as an object for the existing
// `SUPPLIER_CATEGORY_LABELS[key]` call sites.
export const SUPPLIER_CATEGORY_KEYS = UNIFIED_SYSTEMS;

export const SUPPLIER_CATEGORY_LABELS = UNIFIED_SYSTEMS.reduce((acc, name) => {
  acc[name] = name;
  return acc;
}, {});

// Falls back through the legacy slug→name map so old stored rows still label
// nicely until the one-time backend migration rewrites them.
export function labelForSupplierCategory(value) {
  return labelForSystem(value);
}
